module.exports = ".fullwidth{\n    width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/bug/bug.component.css
// module id = ./src/app/bug/bug.component.css
// module chunks = main